import React from 'react';
import { Loader2, Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';
import { api } from '../../services/api';

export const ContactModal = ({
  contactFor, setContactFor, contactMessage, setContactMessage,
  contactSending, setContactSending, formatCurrency,
}) => (
  <Dialog open={!!contactFor} onOpenChange={() => { setContactFor(null); setContactMessage(''); }}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-md" data-testid="contact-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">Message the Owner</DialogTitle></DialogHeader>
      {contactFor && (
        <div className="space-y-4">
          <div className="p-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded">
            <p className="text-white text-sm font-medium">{contactFor.asset_name}</p>
            <p className="text-[11px] text-muted-foreground">{formatCurrency(contactFor.price_per_fraction)} / fraction · {contactFor.fractions_available?.toLocaleString()} available</p>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Your message</label>
            <Textarea
              value={contactMessage}
              onChange={(e) => setContactMessage(e.target.value)}
              rows={5}
              className="luxury-input mt-1 resize-none"
              placeholder="Introduce yourself and what you'd like to discuss..."
              data-testid="contact-message-input"
            />
          </div>
          <p className="text-[10px] text-muted-foreground italic">
            This sends an in-app message. The owner will see it in their inbox and can reply directly. Your identity is shared.
          </p>
          <div className="flex gap-2">
            <Button variant="outline" className="flex-1 border-white/10 text-muted-foreground" onClick={() => { setContactFor(null); setContactMessage(''); }}>Cancel</Button>
            <Button
              className="flex-1 bg-gold text-black hover:bg-gold/90"
              disabled={contactSending || !contactMessage.trim()}
              data-testid="send-message-btn"
              onClick={async () => {
                if (!contactMessage.trim()) return;
                setContactSending(true);
                try {
                  await api.sendMessage({
                    recipient_id: contactFor.seller_id,
                    subject: `Enquiry: ${contactFor.asset_name}`,
                    message: contactMessage.trim(),
                  });
                  toast.success('Message sent. The owner has been notified.');
                  setContactFor(null);
                  setContactMessage('');
                } catch (err) {
                  toast.error(err.response?.data?.detail || 'Failed to send message.');
                } finally { setContactSending(false); }
              }}
            >
              {contactSending ? <Loader2 size={14} className="animate-spin mr-2" /> : <Send size={14} className="mr-2" />}
              Send
            </Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
